var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4.22222C7.70476 4.22222 4.22222 7.70476 4.22222 12C4.22222 16.2952 7.70476 19.7778 12 19.7778C16.2952 19.7778 19.7778 16.2952 19.7778 12C19.7778 7.70476 16.2952 4.22222 12 4.22222ZM2 12C2 6.47746 6.47746 2 12 2C17.5225 2 22 6.47746 22 12C22 17.5225 17.5225 22 12 22C6.47746 22 2 17.5225 2 12Z",
    fill: "#202020"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 10.8889C12.6137 10.8889 13.1111 11.3864 13.1111 12V15.81C13.1111 16.4236 12.6137 16.9211 12 16.9211C11.3864 16.9211 10.8889 16.4236 10.8889 15.81V12C10.8889 11.3864 11.3864 10.8889 12 10.8889Z",
    fill: "#202020"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2696 8.19038C13.2696 8.89149 12.7007 9.46038 11.9996 9.46038C11.2996 9.46038 10.7307 8.89149 10.7307 8.19038C10.7307 7.48927 11.2996 6.92038 11.9996 6.92038C12.7007 6.92038 13.2696 7.48927 13.2696 8.19038Z",
    fill: "#202020"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.3e52e0ebde6e4f202f87b0e976a932d6.svg";
export { ForwardRef as ReactComponent };